export const AudienceLikes = [
  { id: 1, name: "Language" },
  { id: 2, name: "Country" },
  { id: 3, name: "State" },
  { id: 4, name: "City" },
];
export const PerformaceTab = [
  { id: 1, name: "Page clicks" },
  //   { id: 2, name: "Positive Feedbacks" },
  //   { id: 3, name: "Page Views" },
];
export const ReachAndImpressionTab = [
  { id: 1, name: "Pages reach" },
  { id: 2, name: "Pages impression" },

  //   { id: 2, name: "Viral & Non Viral vs Reach" },
  //   { id: 3, name: "Organic & Paid vs Reach" },
];
export const PostAndEngagement = [
  { id: 1, name: "Top 5 Connections" },
  { id: 2, name: "Most Engaged" },
  { id: 3, name: "Top Post" },
];
const dataOld = [
  ["Name", "Age"],
  ["18-24", 9],
  ["25-34", 24],
  ["35-44", 3],
  ["45-54", 3],
  ["55-64", 9],
  [">65+", 2],
];

const dataNew = [
  ["Name", "Age"],
  ["18-24", 6],
  ["25-34", 23],
  ["35-44", 6],
  ["45-54", 0],
  ["55-64", 1],
  [">65+", 0],
];

export const GoogleAge = {
  old: dataOld,
  new: dataNew,
};
export const Clicks = [
  { name: "Jan", clicks: 0 },
  { name: "Feb", clicks: 0 },
  { name: "Mar", clicks: 0 },
  { name: "Apr", clicks: 0 },
  { name: "May", clicks: 0 },
  { name: "Jun", clicks: 0 },
];
export const Impressions = [
  { name: "Jan", impressions: 0 },
  { name: "Feb", impressions: 0 },
  { name: "Mar", impressions: 0 },
  { name: "Apr", impressions: 0 },
  { name: "May", impressions: 0 },
  { name: "Jun", impressions: 0 },
];
export const ReachDummy = [
  { name: "Jan", reach: 0 },
  { name: "Feb", reach: 0 },
  { name: "Mar", reach: 0 },
  { name: "Apr", reach: 0 },
  { name: "May", reach: 0 },
  { name: "Jun", reach: 0 },
];
export const FacebookTab = [
  // { id: 1, name: "Age and Gender" },
  { id: 1, name: "Link clicks" },
  // { id: 3, name: "Top Post" },
];
export const InstagramTab = [
    { id: 1, name: "Engagement Time" },
  //   { id: 2, name: "Link Clicks" },
  // { id: 3, name: "Top Post" },
];
export const FacebookClicks = [
  { name: "Week 1", clicks: 0 },
  { name: "Week 2", clicks: 0 },
  { name: "Week 3", clicks: 0 },
  { name: "Week 4", clicks: 0 },
];
const male = [
  ["Name", "Age"],
  ["13-17", 0],
  ["18-24", 0],
  ["25-34", 0],
  ["35-44", 0],
  ["45-54", 0],
  ["55-64", 0],
  [">65+", 0],
];

const female = [
  ["Name", "Age"],
  ["13-17", 0],
  ["18-24", 0],
  ["25-34", 0],
  ["35-44", 0],
  ["45-54", 0],
  ["55-64", 0],
  [">65+", 0],
];

export const FacebookAge = [
  { data: [0, 0,0, 0,0, 0] },
  { data: [0, 0,0, 0,0, 0]  }
];
